import { FieldDef } from 'app/core/models';
import { RelatedToType } from 'app/shared/enums';
import { CustomObject } from 'app/shared/modules/custom-objects/custom-objects.types';

export type LockedField = {
  id: number;
  created_at: string;
  account_id: number;
  klass: RelatedToType;
  name: string;
  locked_by: string;
  user_id: number;
  user_name: string;
  role_id: number;
  role_name: string;
};

export type LockedFieldCreate = {
  accountId: string;
  fields: string[];
  relatedToType: RelatedToType;
  role_id?: number;
  user_id?: number;
};

export type LockableFieldSaveModel = {
  accountId: string;
  fields: string[];
  relatedToType: RelatedToType;
  users: {
    toAdd: number[];
    toRemove: number[];
  };
  roles: {
    toAdd: number[];
    toRemove: number[];
  };
};

export type FieldDefCustomizationCreate = {
  fields: string[];
  related_to_type: string;
  related_to_id: number;
  customization_name: LockableFieldEditMode;
  customization_value: boolean;
  field_def_related_to_type: string;
};

export type CustomizableFieldSaveModel = {
  fields: string[];
  customization_name: LockableFieldEditMode;
  customization_value: boolean;
  field_def_related_to_type: string;
  users: {
    toAdd: number[];
    toRemove: number[];
  };
  roles: {
    toAdd: number[];
    toRemove: number[];
  };
};

export enum CommonAction {
  fieldSearch = 'fieldSearch',
  addCustomField = 'addCustomField',
  importCustomField = 'importCustomField',
  setLoading = 'setLoading',
  onlyLocked = 'onlyLocked',
  onFieldAdded = 'onFieldAdded',
}

export const routeTypeMap = {
  propertytenant: 'PropertyTenant',
  propertyunit: 'PropertyUnit',
  facilityreport: 'FacilityReport',
  loanquote: 'LoanQuote',
};

export type LockedFieldsResponse = { locked_fields: LockedField[] };
export type LockableFieldDef = FieldDef & { lockInfo: LockedField[] };
export type LockableFieldsResolverDataBase = {
  lockableFields: LockableFieldDef[];
  relatedToTypes: LockableFieldType[];
  customObjects: CustomObject[];
};
export type LockableFieldsResolverData = { lockableFieldsData: LockableFieldsResolverDataBase };
export type LockableFieldEditMode =
  | 'add'
  | 'edit'
  | 'lock'
  | 'value_hidden'
  | 'excel_pull_locked'
  | 'excel_push_locked';
export type CustomOrStandardFieldType = 'custom' | 'standard';
export type LockableFieldEditQueryParams = { mode: LockableFieldEditMode };
export type LockableFieldLockDialogResult = { added?: LockedField[]; removed?: number[] };
export type LockableFieldType = { type: RelatedToType; canLock: boolean; canInherit: boolean };

export type FieldDefCustomization = {
  id: number;
  created_at: string;
  updated_at: string;
  account_id: number;
  field_def_related_to_type: RelatedToType;
  name: string;
  related_to_type: string;
  related_to_id: number;
  created_by_id: number;
  groupable: boolean;
  value_hidden: boolean;
  excel_pull_locked: boolean;
  excel_push_locked: boolean;
};
